<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="
        bg-primary 
        text-white 
        border-0 
        font-weight-bold 
        d-flex
        p-3"
    > {{ this.title_tab }}
    <template v-if="role_status && role_status.status_export_excel">
    <CButton
        color="info"        
        class="btn-md ml-auto mr-2"
        @click="exportPengajuan"
      >Ekspor Excel</CButton>    
    </template> 
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/pelatihan/data-pengajuan-skp/terstruktur"          
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          @click.native="tabchange('Data Pengajuan SKP Terstruktur')"
          aria-selected="true">SKP Tidak Terstruktur <span class="badge badge-danger" style="display:none">0</span></router-link>
      </li>

      <li class="nav-item">
        <router-link
          to="/pelatihan/data-pengajuan-skp/non-terstruktur"
          class="nav-link p-3 px-5 font-weight-bold text-white"              
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          @click.native="tabchange('Data Pengajuan SKP Tidak Terstruktur')"
        >Pengajuan SKP Terstruktur <span class="badge badge-danger" style="display:none">0</span></router-link>
      </li>
    </ul>

    <!-- Data RPL-->
    <router-view></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>
<script>
import { bus } from '../../../../src/main'
export default {
  data() {
    return {
        jenis : 'tidak_terstruktur',
        title_tab : 'Data Pengajuan SKP Terstruktur',
        role_status: null
    };
  },
  mounted() {
    this.mountedchange(this.$router.currentRoute.path);
    this.roleData();
  },
  watch: {
    
  },
  
  methods: {
      roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
      exportPengajuan() {
        if(this.jenis == 'tidak_terstruktur') {
          bus.$emit('exportPengajuanChild1', this.jenis);
        } else {
          bus.$emit('exportPengajuanChild2', this.jenis);
        }
      },
      
      tabchange(value) {
          this.title_tab = value;
          switch (value) {
            case 'Data Pengajuan SKP Terstruktur':
                this.jenis = 'tidak_terstruktur'
                break;
            case 'Data Pengajuan SKP Tidak Terstruktur':
                this.jenis = 'tidak_terstruktur_ke_struktur'
                break;
              default:
                  break;
          }
      },
      mountedchange(value) {
        switch (value) {
            case '/pelatihan/data-pengajuan-skp/terstruktur':
                this.title_tab = 'Data Pengajuan SKP Terstruktur';
                this.jenis = 'tidak_terstruktur'
                break;
            case '/pelatihan/data-pengajuan-skp/non-terstruktur':
                this.title_tab = 'Data Pengajuan SKP Tidak Terstruktur';
                this.jenis = 'tidak_terstruktur_ke_struktur'
                break;
            default:
                break;
        }
      }
  }
};
</script>